module.exports = __webpack_public_path__ + "static/media/speech_08.fe7163d7.svg";